import { Splt_Inst_Cnd } from '../models/domain/splt_inst_cnd';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { ObjectWrapperUtil } from './object.wrapper.util';
import { Util } from './util';

export class Splt_Inst_CndsUtil {
    private static instance: Splt_Inst_CndsUtil;

    static getInstance(): Splt_Inst_CndsUtil {
        if (!Splt_Inst_CndsUtil.instance) {
            Splt_Inst_CndsUtil.instance = new Splt_Inst_CndsUtil();
        }
        return Splt_Inst_CndsUtil.instance;
    }

    /**
     * Splt_Inst_CndsUtil is a singleton class, so use Splt_Inst_CndsUtil.getInstance() method instead of creating new Splt_Inst_CndsUtil().
     */
    private constructor() {

    }

    getNewSplt_Inst_Cnd(objectWrapper: ObjectWrapper, index: number): Splt_Inst_Cnd {
        let splt_Inst_Cnd: Splt_Inst_Cnd = new Splt_Inst_Cnd();

        splt_Inst_Cnd.splt_Inst_Cnd_Id = ObjectWrapperUtil.getInstance().getNewSub_Id(objectWrapper);
        splt_Inst_Cnd.spltCndNm = Util.getInstance().getNewName('CND_NAME_1', objectWrapper.subNames);

        splt_Inst_Cnd.splt_Inst_Id = objectWrapper.obj_Id;
        splt_Inst_Cnd.dxMp_Id = objectWrapper.dxMp_Id;
        splt_Inst_Cnd.srt_Order = index;

        splt_Inst_Cnd.valid_Cd = "EMPT_COND";

        return splt_Inst_Cnd;
    }



    cloneSplt_Inst_Cnd(splt_Inst_Cnd: Splt_Inst_Cnd) {
        let clonedSplt_Inst_CndTmp: Splt_Inst_Cnd = new Splt_Inst_Cnd();
        clonedSplt_Inst_CndTmp.splt_Inst_Cnd_Id = splt_Inst_Cnd.splt_Inst_Cnd_Id;
        clonedSplt_Inst_CndTmp.splt_Inst_Id = splt_Inst_Cnd.splt_Inst_Id;
        clonedSplt_Inst_CndTmp.dxMp_Id = splt_Inst_Cnd.dxMp_Id;
        clonedSplt_Inst_CndTmp.spltCndNm = splt_Inst_Cnd.spltCndNm;
        clonedSplt_Inst_CndTmp.spltCnd = splt_Inst_Cnd.spltCnd;
        clonedSplt_Inst_CndTmp.valid_Cd = splt_Inst_Cnd.valid_Cd;
        clonedSplt_Inst_CndTmp.srt_Order = splt_Inst_Cnd.srt_Order;
        return clonedSplt_Inst_CndTmp;
    }


    copy(splt_Inst_CndsTmp: Array<Splt_Inst_Cnd>): Array<Splt_Inst_Cnd> {
        let splt_Inst_Cnds: Array<Splt_Inst_Cnd> = new Array<Splt_Inst_Cnd>();

        for (let i: number = 0; i < splt_Inst_CndsTmp.length; i++) {
            let splt_Inst_Cnd: Splt_Inst_Cnd = splt_Inst_CndsTmp[i] as Splt_Inst_Cnd;
            splt_Inst_Cnds.push(splt_Inst_Cnd.copy())
        }

        return splt_Inst_Cnds;
    }

    copyFrom(splt_Inst_Cnds: Array<Splt_Inst_Cnd>, splt_Inst_CndsTmp: Array<Splt_Inst_Cnd>): void {
        let splt_Inst_CndsMap: Map<number, Splt_Inst_Cnd> = new Map<number, Splt_Inst_Cnd>();

        for (let i: number = 0; i < splt_Inst_Cnds.length; i++) {
            let splt_Inst_Cnd: Splt_Inst_Cnd = splt_Inst_Cnds[i] as Splt_Inst_Cnd;
            splt_Inst_CndsMap.set(splt_Inst_Cnd.splt_Inst_Cnd_Id, splt_Inst_Cnd);
        }
        splt_Inst_Cnds.splice(0, splt_Inst_Cnds.length);

        for (let i: number = 0; i < splt_Inst_CndsTmp.length; i++) {
            let splt_Inst_CndTmp: Splt_Inst_Cnd = splt_Inst_CndsTmp[i] as Splt_Inst_Cnd;

            let splt_Inst_Cnd: Splt_Inst_Cnd = splt_Inst_CndsMap.get(splt_Inst_CndTmp.splt_Inst_Cnd_Id);
            if (splt_Inst_Cnd) {
                splt_Inst_Cnd.copyFrom(splt_Inst_CndTmp);
            } else {
                splt_Inst_Cnd = Splt_Inst_Cnd.parse(splt_Inst_CndTmp);
            }

            splt_Inst_Cnds.push(splt_Inst_Cnd);
        }
    }

    compare(splt_Inst_Cnds: Array<Splt_Inst_Cnd>, splt_Inst_CndsTmp: Array<Splt_Inst_Cnd>): string {
        let splt_Inst_CndsLength = splt_Inst_Cnds.length;
        let splt_Inst_CndsTmpLength = splt_Inst_CndsTmp.length;

        if (splt_Inst_CndsLength != splt_Inst_CndsTmpLength) {
            return 'Splt_Inst_Cnds length is different.';
        }

        for (let i: number = 0; i < splt_Inst_CndsLength; i++) {
            let splt_Inst_Cnd: Splt_Inst_Cnd = splt_Inst_Cnds[i] as Splt_Inst_Cnd;
            let splt_Inst_CndTmp: Splt_Inst_Cnd = splt_Inst_CndsTmp[i] as Splt_Inst_Cnd;
            if (splt_Inst_Cnd.compare(splt_Inst_CndTmp) != '') {
                return splt_Inst_Cnd.splt_Inst_Cnd_Id + ' is not equal.'
            }
        }

        return '';
    }

    toString(splt_Inst_Cnds: Array<Splt_Inst_Cnd>): string {
        let str: string = "Splt_Inst_Cnd Length: " + splt_Inst_Cnds.length;

        for (let i: number = 0; i < splt_Inst_Cnds.length; i++) {
            str += splt_Inst_Cnds[i].toString();
        }

        return str;
    }
}